import React from 'react';
import { Button } from 'components/common/button';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from 'hooks';

const ChangeLanguageSection: React.FC = () => {
    const { i18n } = useTranslation();
    const [_, setValue] = useLocalStorage('lang', 'pl');

    return (
        <>
            <Button
                type="link"
                style={{ paddingTop: 8, paddingBottom: 8 }}
                onClick={() => {
                    i18n.changeLanguage('pl');
                    setValue('pl');
                }}>
                PL
            </Button>
            <Button
                type="link"
                style={{ paddingTop: 8, paddingBottom: 8 }}
                onClick={() => {
                    i18n.changeLanguage('en');
                    setValue('en');
                }}>
                EN
            </Button>
        </>
    );
};

export default ChangeLanguageSection;
